module.exports = __webpack_public_path__ + "img/pos2croppedsm2.4159dcfb.webp";